import { EyeCloseIcon, EyeIcon } from 'assets/svg'
import React, { useState } from 'react'

interface InputFieldProps {
  name: string
  type?: string
  onChange?: () => void

  onBlur?: () => void
  onFocus?: () => void
  value?: string
  label?: string
  placeholder?: string
  required?: boolean
  className?: string
  icon?: string
  error?: any
  checked?: boolean
  id?: string
  min?: number
}

const InputField: React.FC<InputFieldProps> = ({
  name,
  type = 'text',
  onChange,
  onBlur,
  value,
  label,
  placeholder = 'Enter here',
  required = false,
  className = '',
  icon = '',
  error,
  checked,
  id,
  min,
  onFocus,
  ...props
}) => {
  const [eyeOn, setEyeOn] = useState(false)
  const [fieldType, setFieldType] = useState(type)

  const toggleEyeOn = () => {
    setEyeOn(!eyeOn)
    setFieldType(eyeOn ? 'password' : 'text')
  }

  return (
    <>
      <div className="relative mb-5 w-full">
        {label && (
          <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
          </label>
        )}
        <div className="form-control relative">
          <input
            {...props}
            type={fieldType}
            name={name}
            placeholder={placeholder}
            value={value ?? ''}
            onBlur={onBlur}
            onChange={onChange}
            className={`false min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none ${type === 'password' && 'pr-10'} ${className} ${error ? 'border-red-500' : 'border-transparent'} `}
            checked={checked}
            id={id}
            onFocus={onFocus}
            min={min}
          />

          {icon && (
            <img
              src={icon}
              alt="Icon"
              className="absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2 transform"
            />
          )}

          {type === 'password' && (
            <button
              type="button"
              className="absolute top-1/2 right-3 -translate-y-1/2 transform text-gray-500 hover:text-gray-700"
              onClick={toggleEyeOn}
            >
              {eyeOn ? <EyeCloseIcon className="w-5" /> : <EyeIcon className="w-5" />}
            </button>
          )}
        </div>
        {error && <span className="black mt-0 text-[11px] leading-none text-red-500">{error}</span>}
      </div>
    </>
  )
}

export default InputField
